





























import cartData from 'library/mixins/cart-data'
import CartHeader from './cart-header'
import ListHeader from './list-header'
import LineItem from './line-item'
import CartFooter from './cart-footer'
import EmptyMsg from './empty-msg'

export default

	mixins: [ cartData ]

	components: {
		CartHeader
		ListHeader
		LineItem
		CartFooter
		EmptyMsg
	}

	mounted: -> @$store.dispatch 'cart/fetchUnlessHydrated'

